// @mui
import { styled } from '@mui/material/styles';
import { Typography, Box, Paper } from '@mui/material';
// components
import Logo from '../../../components/logo';
// sections
import { Page } from '../../../components';
import { APP_NAME } from '../../../core/environment/environment';
import { LoginForm } from '../components';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));

const StyledContent = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[24],
  backgroundColor: theme.palette.background.paper,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 4,
    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
    maxWidth: '100%',
    margin: theme.spacing(0, 1),
  },
}));

const StyledLogo = styled(Logo)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(3),
    transform: 'scale(0.9)',
  },
}));

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <>
      <Page title="Login">
        <StyledRoot>
          <StyledLogo />

          <StyledContent elevation={24}>
            <Box textAlign="center" mb={4}>
              <Typography
                variant="h4"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  mb: 1,
                  [(theme) => theme.breakpoints.down('sm')]: {
                    fontSize: '1.5rem',
                  },
                }}
              >
                Welcome Back
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                  mb: 3,
                  [(theme) => theme.breakpoints.down('sm')]: {
                    fontSize: '0.875rem',
                  },
                }}
              >
                Sign in to your {APP_NAME} account
              </Typography>
            </Box>

            <LoginForm />
          </StyledContent>
        </StyledRoot>
      </Page>
    </>
  );
}
